// STATE TYPES

import { PayloadDataWithId, ResponseData } from './@types';

export type BasePriceType = {
  high_season_weekday_price: string | null;
  high_season_weekend_price: string | null;
  start_date: string | null;
  end_date: string | null;
  low_season_weekday_price: string | null;
  low_season_weekend_price: string | null;
};

export type TemplatePriceType = {
  high_season_weekday_price: string;
  high_season_weekend_price: string;
  low_season_weekday_price: string;
  low_season_weekend_price: string;
};
export type KidsPriceType = {
  start_age: number;
  end_age: number | null;
  high_season_weekday_price: string;
  high_season_weekend_price: string;
  low_season_weekday_price: string;
  low_season_weekend_price: string;
};

export type ExtraGuestPriceType = {
  high_season_weekday_price: string;
  high_season_weekend_price: string;
  low_season_weekday_price: string;
  low_season_weekend_price: string;
  min_guests_weekday: number;
  min_guests_weekend: number;
  is_kids_price_active: boolean;
  age_kids_free: number;
};

export type KidsPriceFormType = {
  start_age: number;
  end_age: number | null;
  price: TemplatePriceType;
};

export type PriceFormType = {
  base_price: TemplatePriceType;
  extra_guest_price: {
    high_season_weekday_price: string;
    high_season_weekend_price: string;
    low_season_weekday_price: string;
    low_season_weekend_price: string;
    min_guests_weekday: string;
    min_guests_weekend: string;
  };
  max_places: number | null;
  start_date_month: string;
  start_date_day: string;
  end_date_month: string;
  end_date_day: string;
  has_kidsPrice: boolean;
  ageKidsFree: string;
  isAnimalPrice: boolean;
  animalPrice: string;
  kidsPrice: KidsPriceFormType[] | [];
  isPriceDynamic: boolean;
};

export type CertainDayPriceType = {
  start_date: string;
  end_date: string;
  base_price: string;
  extra_guest_price: string;
  min_guests: string;
};

export type CertainDayPriceTypeList = CertainDayPriceType[];

export type CertainDayPriceStatus = {
  id: number;
  isNew: boolean;
  isLoading: boolean;
  isSuccess: boolean;
};

export type CertainDayPriceStatusList = CertainDayPriceStatus[];

// PAYLOAD TYPES

export type UpdatePricePayload = PayloadDataWithId<UpdatePriceType>;

export type CreateCertainDayPricePayloadData = {
  start_date: string;
  end_date: string;
  base_price: string;
  extra_guest_price: string;
  min_guests: string;
  rental_object: number;
};

export type CreateCertainDayPricePayload =
  PayloadDataWithId<CreateCertainDayPricePayloadData>;

export type UpdateCertainDayPricePayloadData = {
  start_date?: string;
  end_date?: string;
  base_price?: string;
  extra_guest_price?: string;
  min_guests?: string;
};

export type UpdateCertainDayPricePayload =
  PayloadDataWithId<UpdateCertainDayPricePayloadData>;

// RESPONSE TYPES

export type ResponsePriceType = {
  is_dynamic: boolean;
  is_animal_price_active: boolean;
  animal_price: string | null;
  id: number;
  base_price: BasePriceType;
  extra_guest_price: ExtraGuestPriceType | null;
  rental_object: number;
  kids_prices: KidsPriceType[] | null;
};

export type UpdatePriceType = {
  is_dynamic?: boolean;
  is_animal_price_active?: boolean;
  animal_price?: string | null;
  base_price?: {
    high_season_weekday_price?: string;
    high_season_weekend_price?: string;
    start_date?: string;
    end_date?: string;
    low_season_weekday_price?: string;
    low_season_weekend_price?: string;
  };
  extra_guest_price?: {
    high_season_weekday_price?: string;
    high_season_weekend_price?: string;
    low_season_weekday_price?: string;
    low_season_weekend_price?: string;
    min_guests_weekday?: number;
    min_guests_weekend?: number;
    is_kids_price_active?: boolean;
    age_kids_free?: number;
  };
  kids_prices?: KidsPriceType[] | null;
};
export type ResponseCertainDayPriceType = {
  id: number;
  start_date: string;
  end_date: string;
  base_price: string;
  extra_guest_price: string;
  min_guests: string;
  rental_object: number;
};

export type ResponseCertainDayPriceTypeList = ResponseCertainDayPriceType[];

export type CertianDayPricesResponseData =
  ResponseData<ResponseCertainDayPriceTypeList>;

export enum PriceVariant {
  REGULAR_HIGH = 'regular_high',
  WEEKEND_HIGH = 'weekend_high',
  REGULAR_LOW = 'regular_low',
  WEEKEND_LOW = 'weekend_low',
  CERTAIN = 'certain',
}
